import FormDialog from "../../../components/dialog/form/FormDialog.vue";
import AutocompleteField from "../../../components/fields/autocompleteField/AutocompleteField.vue";
import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import moment from "moment";
//import { FeriasEscolaresService } from "../../../services/FeriasEscolaresService";
import { FeriasService } from "../../../services/FeriasService";
import { FeriasEscolaresService } from "../../../services/FeriasEscolaresService";

import DefinirFeriasEscolares from "./definir-ferias-escolares/DefinirFeriasEscolares.vue";
import AnalisarFeriasEscolares from "../../ferias-escolares/analisar-ferias-escolares/AnalisarFeriasEscolares.vue";

import { tipoPerfil } from "../../../constants";

import { SnackBarModule } from "../../../modules/SnackBarModule";
import { numeroBmMixin } from "../../../mixins/numeroBmMixin";




export default {
  name: "FeriasEscolares",

  components: {
    FormDialog,
    AutocompleteField,
    TextField,
    PeriodoField,
    DefinirFeriasEscolares,
    AnalisarFeriasEscolares
  },

  mixins:[numeroBmMixin],

  data: () => ({
    totalItems: 0,
    perfilid: null,
    headers: [
      { text: "Nº BM", value: "numero", width: "6%"  },
      { text: "Posto/Graduação", value: "graduacao", width: "180px"  },
      { text: "Nome", value: "nome", width: "150px",  },
      { text: "Unidade", value: "unidade", width: "160px", align: "center"  },
      { text: "Lotação", value: "lotacao", width: "160px", align: "center"  },
      { text: "Exercício", value: "exercicio", width: "120px", align: "center"  },
      { text: "Período de Férias", value: "periodo", width: "200px", align: "center"  },
      { text: "Dias de Férias", value: "diasFerias", width: "140px", align: "center"  },
      { text: "Dias Restantes", value: "diasRestantes", width: "140px", align: "center"  },
      { text: "Parcela", value: "parcela", width: "110px" },
      { text: "Status", value: "status", width: "140px" },
      { text: "Ações", value: "actions", sortable: false, align: "center" },
    ],

    data: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    usersSelecteds: [],
    selected:[],
    disabledLotacao: true,
    unidade: null,
    unidadePodeDefinirFerias: false,

    definirFeriasDialog:false,
    analiseFeriasDialog:false,

 
    optionsFilter: {
      postoGraduacao: [],
      status: [],
      unidadeLotacao: [],
      exercicioPesquisar: [],
      lotacao: []
    },

    loading: {
      table: false,
      btn: false,
      field: false,
    },
    form: {},
    filter: {},
  
  }),

  beforeMount() {
    this.initializeFilter();
    this.getFerias();
    this.getExercicioPesquisar();
    this.verificaSeUnidadePermiteDefinirFerias(this.$store.state.user.Unidade.id);
  },
  mounted() {
    this.getFerias();
    this.getUnidadeItems();
    this.getGraduacaoItems();
  },

  watch: {
    page: function(val) {
      this.page = val;
      this.getFerias();
    },
    unidade : function(unidade) {
      if (unidade) {
        this.getLotacoesItems(unidade);
        this.disabledLotacao = false;
      } else {
        this.disabledLotacao = true;
        this.unidade = null;
        this.filter.lotacao = null;
      }
    },
    selected: function(){
      this.selected.forEach((val, index) => {
        let array = this.selected[index + 1];
        let verificar = (val.periodo != array.periodo || val.diasRestantes != array.diasRestantes) || val.idStatus != array.idStatus;
        if(verificar){
          this.selected = [];

          SnackBarModule('As datas, exercícios e os status selecionados precisam ser iguais','error')
        }
      })
    }
  },

  methods: {
    initializeForm() {
      this.form = {
        perfil: "",
      };
    },

    initializeFilter() {
      this.filter = {
        dataInicio: null,
        dataFim: null,
        nomeUsuario: null,
        unidadeLotacao:null,
        exercicio:null,
        postoGraduacao:null,
      };
    },

    verificarCheckBox(item){
      
      if (this.$store.state.user.Unidade.id != item.idUnidade) {
        return false;
      }

      if( this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1 ){
        if(item.idStatus == 0 || item.idStatus == 1){
          return true;
        }
      }

      if( this.$store.state.user.Perfis.indexOf(tipoPerfil['COMANDANTE']) != -1 ){
        if(item.idStatus == 6 ){
          return true;
        }
      }

      return false;
     
    },

    async getLotacoesItems(unidade) {
      this.loading.field = true;
      const response = await FeriasService.getLotacaoByUnidade(unidade);
      this.optionsFilter.lotacao = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.loading.field = false;
    },

    async getUnidadeItems() {
      this.loading.field = true;
      const response = await FeriasService.getUnidade();
      this.optionsFilter.unidadeLotacao = response.map((el) => {
        return {
          text: el.nome_abreviado,
          value: el.id,
        };
      });
      this.optionsFilter.unidadeLotacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    },

    async getExercicioPesquisar() {
      this.loading.field = true;
      const response = await FeriasEscolaresService.getExerciciosPesquisar();
      this.optionsFilter.exercicioPesquisar = response.map((el) => {
        return {
          text: el.ano,
          value: el.ano,
        };
      });
      this.optionsFilter.exercicio?.unshift({ text: "Selecione", value: "" });
      this.loading.field = false;
    },

    async getGraduacaoItems() {
      this.loading.field = true;
      const response = await FeriasService.getGraduacao();
      this.optionsFilter.postoGraduacao = response.map((el) => {
        return {
          text: el.descricao,
          value: el.id,
        };
      });
      this.optionsFilter.postoGraduacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    },

    prepareFormFilter() {
      const filter = new FormData();
      filter.append("page", this.page);

      if (this.filter.numeroBM) {
        const numeroBM = this.filter.numeroBM.replace(".", "");
        const [numero, digitoVerificador] = numeroBM.split("-");
        filter.append("numero", this.removerZero(numero));
        if (digitoVerificador != undefined) filter.append("digito_verificador", digitoVerificador);
      }    

      this.filter.nomeUsuario
        ? filter.append("nome", this.filter.nomeUsuario)
        : null;
      this.filter.postoGraduacao
        ? filter.append("id_graduacao", this.filter.postoGraduacao)
        : null;
      this.filter.status ? filter.append("status", this.filter.status) : null;
      this.filter.dataInicio
        ? filter.append(
            "data_ini",
            moment(this.filter.dataInicio).format("YYYY-MM-DD")
          )
        : null;
      this.filter.dataFim
        ? filter.append(
            "data_fin",
            moment(this.filter.dataFim).format("YYYY-MM-DD")
          )
        : null;
      this.unidade
        ? filter.append("id_unidade", this.unidade)
        : null;
      this.filter.lotacao
        ? filter.append("id_lotacao", this.filter.lotacao)
        : null;
      this.filter.exercicio
        ? filter.append("exercicio", this.filter.exercicio)
        : null;

      return filter;
    },

    mostrarDialogDefinirFerias(item){
      this.selected.push(item);
      this.definirFeriasDialog = true;
    },

    async getFerias() {
      this.loading.table = true;
      const filter = this.prepareFormFilter();
      const response = await FeriasEscolaresService.getFeriasEscolares(filter);
      this.data = response.data;
      this.pageCount = response.last_page;
      this.totalItems = response.total;
      this.loading.table = false;
    },

    async verificaSeUnidadePermiteDefinirFerias (unidadeId)
    {
      const response = await FeriasEscolaresService.verificaSeUnidadePermiteDefinirFerias(unidadeId);
      this.unidadePodeDefinirFerias = response.pode;
    },

    verificarDefiniFerias(){
      return this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1 || this.unidadePodeDefinirFerias;
    },

    verificarAnalisarFerias(){
      return this.$store.state.user.Perfis.indexOf(tipoPerfil['COMANDANTE']) != -1
    },

    verificarAjustarFerias(){
      return this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1 || this.$store.state.user.Perfis.indexOf(tipoPerfil['SEPLAN_ENSINO']) != -1
    },

    goTo(path) {
      this.$router.push(path);
    },

    onClose(){
      this.analiseFeriasDialog = false
      this.definirFeriasDialog = false;
      this.selected = [];
      this.getFerias();
    },

    mostrarDialogAnalisarFerias(item){
      this.selected.push(item);
      this.analiseFeriasDialog = true;
    },

  },
};